import * as moment from "moment";

declare const DEVELOPMENT: boolean;

interface Config {
  api: {
    host: string;
  };
  cookieExpiration: Date;
}

const thisConfig: Config = {
  api: {
    host: "https://api.santa.co.uk/graphql"
  },
  cookieExpiration: moment().add(3, "months").toDate()
};

if (DEVELOPMENT) {
  thisConfig.api.host = "http://localhost:8020/graphql";
}

export const config = thisConfig;



// WEBPACK FOOTER //
// ./src/config.ts